import React from 'react';
import { I18NextLangFollowsPastBookingLang } from '~/components/util/I18NextLangFollowsRedux';
import { WhiteLabelWrapper } from '~/components/util/WhiteLabelWrapper';
import { requireNamespaces } from '~/locale/i18n';
import {
  ConnectedPaperworkStart,
  ConnectedPaperworkPatient,
  ConnectedPaperworkEmployer,
  ConnectedPaperworkHealthcareContacts,
  ConnectedPaperworkPayment,
  ConnectedPaperworkCustomFields,
  ConnectedPaperworkFinalize,
  ConnectedPaperworkConsent,
  ConnectedPaperworkComplete,
  ConnectedPaperworkVerificationAndReview,
} from '../../components/Paperwork/connected';
import { PaperworkBookingIdContext } from './PaperworkBookingIdContext';

const namespaces = requireNamespaces('paperwork', 'common');

const paperworkStartFlow = (context: any) => ({
  chunks: ['paperwork'],

  component: (
    <PaperworkBookingIdContext.Provider value={context.params.id}>
      <I18NextLangFollowsPastBookingLang bookingId={context.params.id}>
        <WhiteLabelWrapper bookingId={context.params.id}>
          <ConnectedPaperworkStart bookingId={context.params.id} />
        </WhiteLabelWrapper>
      </I18NextLangFollowsPastBookingLang>
    </PaperworkBookingIdContext.Provider>
  ),
  accountWrapper: { loginRequired: false },
  ...namespaces,
});

const paperworkPatientFlow = (context: any) => ({
  chunks: ['paperwork'],

  component: (
    <PaperworkBookingIdContext.Provider value={context.params.id}>
      <I18NextLangFollowsPastBookingLang bookingId={context.params.id}>
        <WhiteLabelWrapper bookingId={context.params.id}>
          <ConnectedPaperworkPatient bookingId={context.params.id} />
        </WhiteLabelWrapper>
      </I18NextLangFollowsPastBookingLang>
    </PaperworkBookingIdContext.Provider>
  ),
  accountWrapper: { loginRequired: false },
  ...namespaces,
});

const paperworkEmployerFlow = (context: any) => ({
  chunks: ['paperwork'],

  component: (
    <PaperworkBookingIdContext.Provider value={context.params.id}>
      <I18NextLangFollowsPastBookingLang bookingId={context.params.id}>
        <WhiteLabelWrapper bookingId={context.params.id}>
          <ConnectedPaperworkEmployer bookingId={context.params.id} />
        </WhiteLabelWrapper>
      </I18NextLangFollowsPastBookingLang>
    </PaperworkBookingIdContext.Provider>
  ),
  accountWrapper: { loginRequired: false },
  ...namespaces,
});

const paperworkHealthcareContactsFlow = (context: any) => ({
  chunks: ['paperwork'],

  component: (
    <PaperworkBookingIdContext.Provider value={context.params.id}>
      <I18NextLangFollowsPastBookingLang bookingId={context.params.id}>
        <WhiteLabelWrapper bookingId={context.params.id}>
          <ConnectedPaperworkHealthcareContacts bookingId={context.params.id} />
        </WhiteLabelWrapper>
      </I18NextLangFollowsPastBookingLang>
    </PaperworkBookingIdContext.Provider>
  ),
  accountWrapper: { loginRequired: false },
  ...namespaces,
});

const paperworkPaymentFlow = (context: any) => ({
  chunks: ['paperwork'],

  component: (
    <PaperworkBookingIdContext.Provider value={context.params.id}>
      <I18NextLangFollowsPastBookingLang bookingId={context.params.id}>
        <WhiteLabelWrapper bookingId={context.params.id}>
          <ConnectedPaperworkPayment bookingId={context.params.id} />
        </WhiteLabelWrapper>
      </I18NextLangFollowsPastBookingLang>
    </PaperworkBookingIdContext.Provider>
  ),
  accountWrapper: { loginRequired: false },
  ...namespaces,
});

const paperworkCustomFlow = (context: any) => ({
  chunks: ['paperwork'],

  component: (
    <PaperworkBookingIdContext.Provider value={context.params.id}>
      <I18NextLangFollowsPastBookingLang bookingId={context.params.id}>
        <WhiteLabelWrapper bookingId={context.params.id}>
          <ConnectedPaperworkCustomFields bookingId={context.params.id} />
        </WhiteLabelWrapper>
      </I18NextLangFollowsPastBookingLang>
    </PaperworkBookingIdContext.Provider>
  ),
  accountWrapper: { loginRequired: false },
  ...namespaces,
});

const paperworkVerificationAndReviewFlow = (context: any) => ({
  chunks: ['paperwork'],

  component: (
    <PaperworkBookingIdContext.Provider value={context.params.id}>
      <I18NextLangFollowsPastBookingLang bookingId={context.params.id}>
        <WhiteLabelWrapper bookingId={context.params.id}>
          <ConnectedPaperworkVerificationAndReview bookingId={context.params.id} />
        </WhiteLabelWrapper>
      </I18NextLangFollowsPastBookingLang>
    </PaperworkBookingIdContext.Provider>
  ),
  accountWrapper: { loginRequired: false },
});

const paperworkConsentFlow = (context: any) => ({
  chunks: ['paperwork'],

  component: (
    <PaperworkBookingIdContext.Provider value={context.params.id}>
      <I18NextLangFollowsPastBookingLang bookingId={context.params.id}>
        <WhiteLabelWrapper bookingId={context.params.id}>
          <ConnectedPaperworkConsent bookingId={context.params.id} />
        </WhiteLabelWrapper>
      </I18NextLangFollowsPastBookingLang>
    </PaperworkBookingIdContext.Provider>
  ),
  accountWrapper: { loginRequired: false },
  ...namespaces,
});

const paperworkFinalizeFlow = (context: any) => ({
  chunks: ['paperwork'],

  component: (
    <PaperworkBookingIdContext.Provider value={context.params.id}>
      <I18NextLangFollowsPastBookingLang bookingId={context.params.id}>
        <WhiteLabelWrapper bookingId={context.params.id}>
          <ConnectedPaperworkFinalize bookingId={context.params.id} />
        </WhiteLabelWrapper>
      </I18NextLangFollowsPastBookingLang>
    </PaperworkBookingIdContext.Provider>
  ),
  accountWrapper: { loginRequired: false },
  ...namespaces,
});

const paperworkCompleteFlow = (context: any) => ({
  chunks: ['paperwork'],

  component: (
    <PaperworkBookingIdContext.Provider value={context.params.id}>
      <I18NextLangFollowsPastBookingLang bookingId={context.params.id}>
        <WhiteLabelWrapper bookingId={context.params.id}>
          <ConnectedPaperworkComplete bookingId={context.params.id} />
        </WhiteLabelWrapper>
      </I18NextLangFollowsPastBookingLang>
    </PaperworkBookingIdContext.Provider>
  ),
  accountWrapper: { loginRequired: false },
  ...namespaces,
});

export {
  paperworkStartFlow,
  paperworkPatientFlow,
  paperworkEmployerFlow,
  paperworkHealthcareContactsFlow,
  paperworkPaymentFlow,
  paperworkCustomFlow,
  paperworkVerificationAndReviewFlow,
  paperworkConsentFlow,
  paperworkFinalizeFlow,
  paperworkCompleteFlow,
};

if (module.hot) {
  module.hot.accept();
}
